import { all, call, put, select, take, takeLatest } from 'redux-saga/effects'
import {
  IRequestEventPdf,
  requestEventPdfFailure,
  requestEventPdfSuccess,
} from '../../actions/events/fetchEventPdf'
import { callFetch } from '../../actions/fetch'
import fetchEventPdf from '../../models/Event/fetchEventPdf'
import { EventPdfActions } from '../../reducers/events/actionNames'
import { getSelectedLanguage } from '../../reducers/userAccount/selectors/userLanguage'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

function* loadEventPdf(action: IRequestEventPdf) {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchEventPdf)
    const [{ service }, language] = yield all([
      take(actionNames.output),
      select(getSelectedLanguage),
      put(callFetch(actionNames.input, actionNames.output, fetchEventPdf)),
    ])

    const pdf = yield call(service, action.eventId, language)
    yield put(requestEventPdfSuccess(pdf))
  } catch (e) {
    yield put(requestEventPdfFailure(e.message))
  }
}

export default function* () {
  yield takeLatest(EventPdfActions.EventPdfRequest, loadEventPdf)
}
